import { useEffect, useState } from "react";
import { fileObjectUrl, isPrivateFileUrl } from "../../helpers/secure.file";

export default function useMediaUrl(document) {
  const file = document?.file;
  const link = document?.url;
  const [fileUrl, setFileUrl] = useState("");
  const [privateMedia, setPrivateMedia] = useState(null);
  let linkUrl = "";
  try {
    const url = link && new URL(link, window.location.origin);
    if (url && ["http:", "https:"].includes(url.protocol)) linkUrl = url.href;
  } catch {
    // Invalid links are not rendered.
  }
  const privateLink = !file && isPrivateFileUrl(linkUrl) ? linkUrl : "";

  useEffect(() => {
    if (!privateLink) return;
    let active = true;
    fileObjectUrl(privateLink)
      .then((url) => { if (active) setPrivateMedia({ link: privateLink, url }); })
      .catch(() => { if (active) setPrivateMedia(null); });
    return () => { active = false; };
  }, [privateLink]);
  useEffect(() => {
    if (!file) {
      setFileUrl("");
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setFileUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);
  if (file) return fileUrl;
  if (privateLink) return privateMedia?.link === privateLink ? privateMedia.url : "";
  return linkUrl;
}
